import Instance from '../common/request/requestService.js'


export default {
  //走进磐石
  getMine: () => {
    return Instance.paramsGet('/api/AboutUs/Get');
  },
}